import { render, staticRenderFns } from "./SetupProfile.vue?vue&type=template&id=08d69bec&scoped=true&"
import script from "./SetupProfile.vue?vue&type=script&lang=js&"
export * from "./SetupProfile.vue?vue&type=script&lang=js&"
import style0 from "./SetupProfile.vue?vue&type=style&index=0&id=08d69bec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d69bec",
  null
  
)

component.options.__file = "SetupProfile.vue"
export default component.exports